import React, { useMemo, useRef } from "react";
import { DndContext, DragOverlay } from "@dnd-kit/core";
import KanbanColumn from "../../../components/AgileKanban/KanbanColumn";
import { useAglieKanban } from "../../../Hooks/Features/aglieKanban/useAglieKanban";
import { Dialog } from "primereact/dialog";
import { SkeletonContainer } from "../../../components/Loader/Loader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "primereact/dropdown";
import { useCommon } from "../../../Hooks/Common/useCommon";

const AgileKanban = () => {
    const { checkPermission } = useCommon();
    const tagRef = useRef(null);
    const { tasks, sensors, activeTask, handleDragStart, handleDragEnd, columns, customCollisionDetection, option, handleChange, showPopup, setShowPopup, details, loader, expanded, setExpanded, selectedValue, setSelectedValue, allowedColumns, handleDragOver, moveSelectedToColumn, selectedTaskIds, setSelectedTaskIds, selectedDestination, setSelectedDestination } = useAglieKanban();


    const columnsMemo = useMemo(() => (
        columns.map(col => (
            <KanbanColumn
                key={col.status_key_name}
                status={col.status_key_name}
                title={col.status_key_name}
                // tasks={tasks[col.status_key_name] || []}
                tasks={allowedColumns.includes(col.status_key_name) ? (tasks[col.status_key_name] || []) : []}
                isDisabled={!allowedColumns.includes(col.status_key_name)}
                option={option}
                handleChange={handleChange}
                setShowPopup={setShowPopup}
                selectedTaskIds={selectedTaskIds}
                setSelectedTaskIds={setSelectedTaskIds}
            />
        ))
    ), [columns, tasks, option, selectedTaskIds, allowedColumns, handleChange, setShowPopup]);

    return (
        <div ref={() => checkPermission("Kanban", tagRef)}>
            <div ref={tagRef} id='{"tabname": "bucket_planning", "data": "agileplanning_kanban_board_tab"}' className="kanban-board">
                <div className="d-flex justify-content-end mb-2">
                    <select onChange={(e) => setSelectedDestination(e.target.value)}>
                        <option value="">Select column</option>
                        {columns.map(col => (
                            <option key={col.status_key_name} value={col.status_key_name}>{col.status_key_name}</option>
                        ))}
                    </select>
                    <button
                        onClick={() => moveSelectedToColumn(selectedDestination)}
                        disabled={selectedTaskIds.size === 0 || !selectedDestination}
                    >
                        Move Selected
                    </button>
                </div>
                <div style={{ height: "97%", overflowY: "auto" }}>
                    {
                        loader ? <div className="d-flex flex-column gap-2 justify-content-between w100 " style={{ height: "100%" }}>
                            {Array.from({ length: 5 }, (_, index) => (
                                <SkeletonContainer key={index} />
                            ))}
                        </div> :
                            <DndContext
                                sensors={sensors}
                                collisionDetection={customCollisionDetection}
                                onDragStart={handleDragStart}
                                onDragEnd={handleDragEnd}
                                onDragOver={handleDragOver}
                            >
                                <div className="d-flex flex-column gap-3">
                                    {columnsMemo}
                                </div>
                                <DragOverlay>
                                    {activeTask && (
                                        <div className="overlay">
                                            {activeTask.issue_summary.length > 100
                                                ? activeTask.issue_summary.slice(0, 100) + "..."
                                                : activeTask.issue_summary}
                                        </div>
                                    )}
                                </DragOverlay>
                            </DndContext>
                    }

                </div>
                <Dialog
                    className='modal-large'
                    modal={true}
                    draggable={false}
                    visible={showPopup?.show}
                    onHide={() => setShowPopup({ show: false, data: {} })}
                    header={() => { return <p> {showPopup?.data?.feature_issue_key} / {showPopup?.data?.issue_key}</p> }}
                >
                    <div className="d-flex gap-2">
                        <div className="w60">
                            <div>
                                <p className="text-black fw-semibold" style={{ wordBreak: "break-word", fontSize: "22px", lineHeight: "normal" }}>{showPopup?.data?.issue_summary}</p>
                                <div className="my-2">
                                    <div className="my-2">
                                        <h5 className="text-black">Description</h5>
                                        <p>None</p>
                                    </div>
                                    <div>
                                        <p>Acceptance Criteria</p>
                                        <p>None</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="w40">
                            <div className="w50 py-2">
                                <Dropdown value={selectedValue?.status} onChange={(e) => setSelectedValue((prev) => ({ ...prev, status: e.value }))} placeholder="Status" options={columns} optionLabel="status_key_name" className="input-dd"
                                    filter filterInputAutoFocus />
                            </div>
                            <div className="border p-2">
                                <div className="d-flex justify-content-between w100 c-pointer align-items-center" onClick={() => setExpanded(!expanded)}>
                                    <span style={{ fontSize: "16px" }}>Details  </span>  <FontAwesomeIcon icon={expanded ? "fa-solid fa-angle-down" : "fa-solid fa-angle-right"} />
                                </div>
                                {
                                    expanded && <div className="border-top py-2">
                                        {Object.entries(details).map(([label, value]) => (
                                            <div key={label} className="py-1 d-flex">
                                                <strong style={{ width: "40%" }}>{label}:</strong>
                                                <div>{value}</div>
                                            </div>
                                        ))
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </Dialog >
            </div >
        </div >
    );
};

export default React.memo(AgileKanban);
